import React, {useState} from "react";
import {
    Box,
    Checkbox,
    CircularProgress,
    Collapse,
    Divider,
    IconButton,
    Link,
    List,
    ListItem,
    ListItemText,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const AppointmentRequestsList = ({requests, markHandler}) => {
    const [showCompleted, setShowCompleted] = useState(false);
    const [processingId, setProcessingId] = useState(null);
    const [expandedPosts, setExpandedPosts] = useState({});

    const activeRequests = requests.filter(r => !r.success);
    const completedRequests = requests.filter(r => r.success);

    const formatDate = (val) => {
        if (!val) return "";
        try {
            return new Date(val).toLocaleString([], {dateStyle: 'short', timeStyle: 'short'});
        } catch {
            return String(val);
        }
    };

    const handleToggleComplete = async (request) => {
        if (request.success) return;
        setProcessingId(request.id);
        try {
            console.log(request)
            await markHandler(request.id, request.userId);
        } catch (e) {
            alert(e?.response?.data?.error || "Не удалось обновить заявку");
        } finally {
            setProcessingId(null);
        }
    };

    const togglePostExpand = (postId) => {
        setExpandedPosts(prev => ({...prev, [postId]: !prev[postId]}));
    };

    const renderRequest = (request) => (
        <ListItem
            key={request.id}
            dense
            sx={{
                alignItems: "flex-start",
                opacity: request.success ? 0.6 : 1,
                pl: 0,
            }}
        >
            <Checkbox
                checked={request.success}
                disabled={request.success || processingId === request.id}
                onChange={() => handleToggleComplete(request)}
                sx={{pt: 0}}
            />
            {processingId === request.id ? (
                <CircularProgress size={20} sx={{mt: 1, mr: 1}}/>
            ) : null}
            <ListItemText
                primary={
                    <Box>
                        <Typography variant="body2" fontWeight={request.success ? 400 : 600}>
                            Запрос на запись
                        </Typography>
                        {request.description && (
                            <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>
                                {request.description}
                            </Typography>
                        )}
                        {request.doctor && (
                            <Typography variant="caption" color="text.secondary">
                                Врач: {request.doctor.name}
                            </Typography>
                        )}
                        {request.service && (
                            <Typography variant="caption" color="text.secondary" display="block">
                                Услуга: {request.service.name}
                            </Typography>
                        )}
                        {request.post && (() => {
                            const content = request.post.content?.trim() || '';
                            const isExpanded = expandedPosts[request.post.id];
                            const needsTruncate = content.length > 150;
                            return (
                                <Box>
                                    <Typography variant="caption" color="text.secondary" display="block">
                                        <strong>Акция:</strong>{' '}
                                        {isExpanded || !needsTruncate
                                            ? content
                                            : content.substr(0, 150) + '...'
                                        }
                                    </Typography>
                                    {needsTruncate && (
                                        <Link
                                            component="button"
                                            variant="caption"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                togglePostExpand(request.post.id);
                                            }}
                                            sx={{ml: 0.5, fontSize: '0.7rem'}}
                                        >
                                            {isExpanded ? 'скрыть' : 'показать всё'}
                                        </Link>
                                    )}
                                </Box>
                            );
                        })()}
                    </Box>
                }
                secondary={
                    <Typography variant="caption" color="text.secondary">
                        {formatDate(request.createdAt)}
                        {request.success && request.admin && ` • Выполнено: ${request.admin.internalName || request.admin.name}`}
                    </Typography>
                }
            />
        </ListItem>
    );

    return (
        <Box sx={{mt: 1}}>
            {activeRequests.length === 0 && completedRequests.length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={{px: 2, py: 1}}>
                    Нет заявок
                </Typography>
            ) : (
                <>
                    <List dense sx={{pt: 0}}>
                        {activeRequests.map(renderRequest)}
                    </List>

                    {completedRequests.length > 0 && (
                        <>
                            <Divider sx={{my: 1}}/>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    pl: 1,
                                }}
                                onClick={() => setShowCompleted(!showCompleted)}
                            >
                                <IconButton size="small">
                                    {showCompleted ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                                </IconButton>
                                <Typography variant="body2" color="text.secondary">
                                    Выполненные ({completedRequests.length})
                                </Typography>
                            </Box>
                            <Collapse in={showCompleted}>
                                <List dense sx={{pt: 0}}>
                                    {completedRequests.map(renderRequest)}
                                </List>
                            </Collapse>
                        </>
                    )}
                </>
            )}
        </Box>
    );
};

export default AppointmentRequestsList;
